module.exports = __webpack_public_path__ + "static/media/checklist1-min.884c3199.png";